import Api from "@/config/Api";

export default {
  getSubscriptions() {
    return Api().get(`/subscriptions`, {});
  },
  trialToSubscription() {
    return Api().post(`/subscriptions/trial`, {});
  },
  paySubscription(data) {
    return Api().post("/subscriptions/pay", data);
  },
  payPpSubscription(data) {
    return Api().post("/subscriptions/pp/pay", data);
  },
  // Licencias de usuario adicionales (mismo precio que la licencia principal).
  // skipErrorNotification: sin plan vigente responde 422 y no es un error.
  getSeatsQuote(quantity = 1) {
    return Api().get("/subscriptions/seats/quote", {
      params: { quantity },
      skipErrorNotification: true
    });
  },
  paySeatsPp(data) {
    return Api().post("/subscriptions/seats/pp/pay", data);
  },
  checkoutSubscription(data) {
    return Api().post("/subscriptions/checkout", data);
  },
  checkoutPpSubscription(data) {
    return Api().post("/subscriptions/pp/checkout", data);
  },
  downloadInvoiceSubscription(subscriptionId) {
    return Api().get(`/subscriptions/download/invoices/${subscriptionId}`, {
      responseType: "arraybuffer"
    });
  },
  membershipCheckout(data) {
    return Api().post("/checkout", data);
  },

  membershipCancel(userId) {
    return Api().get(`/cancelplan/${userId}`, {});
  },
  getPayAdditionals() {
    return Api().get(`/additional`, {});
  },
  postPayAdditional(data) {
    return Api().post(`/additional/checkout`, data);
  },
  getTrialConfig() {
    return Api().get(`/trial-config`);
  },
  getTrialPlans() {
    return Api().get(`/trial-config/plans`);
  },
  updateTrialConfig(data) {
    return Api().put(`/admin/trial-config`, data);
  },

  // New endpoints for plans overhaul
  getUserPlan() {
    return Api().get(`/user/plan`);
  },
  validateCoupon(data) {
    return Api().post(`/coupons/validate`, data);
  },
  upgradePreview(data) {
    return Api().post(`/subscriptions/upgrade`, data);
  },
  downgrade(data) {
    return Api().post(`/subscriptions/downgrade`, data);
  },

  // Bank transfer payment
  getBankAccounts() {
    return Api().get(`/bank-accounts`);
  },
  payTransfer(formData) {
    return Api().post(`/subscriptions/transfer`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },

  // Add-on de WhatsApp / Módulo de marketing (pivote 2026-07-28) —
  // transacción PayPhone independiente de la del plan, no toca los
  // endpoints de arriba.
  getWhatsappAddonPlan() {
    return Api().get(`/whatsapp/addon/plan`);
  },
  getWhatsappAddonStatus() {
    return Api().get(`/whatsapp/addon/status`);
  },
  activateWhatsappAddonPp(data) {
    return Api().post(`/whatsapp/addon/activate/pp/pay`, data);
  },
  checkoutActivateWhatsappAddonPp(data) {
    return Api().post(`/whatsapp/addon/activate/pp/checkout`, data);
  },
  topupWhatsappWalletPp(data) {
    return Api().post(`/whatsapp/addon/topup/pp/pay`, data);
  },
  checkoutTopupWhatsappWalletPp(data) {
    return Api().post(`/whatsapp/addon/topup/pp/checkout`, data);
  },
  setWhatsappAutoRecharge(data) {
    return Api().post(`/whatsapp/addon/auto-recharge`, data);
  },

  getWhatsappWalletBalance() {
    return Api().get(`/whatsapp/addon/wallet-balance`);
  },

  // Packs de créditos de IA — misma transacción PayPhone independiente.
  getAiCreditPacks() {
    return Api().get(`/ai-credits/packs`);
  },
  getAiCreditsStatus() {
    return Api().get(`/ai-credits/status`);
  },
  payAiCreditPackPp(data) {
    return Api().post(`/ai-credits/pp/pay`, data);
  },
  checkoutAiCreditPackPp(data) {
    return Api().post(`/ai-credits/pp/checkout`, data);
  }
};
